/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidorexpiredverificationcode4Inputs */

const en_invalidorexpiredverificationcode4 = /** @type {(inputs: Invalidorexpiredverificationcode4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid or expired verification code.`)
};

const de_invalidorexpiredverificationcode4 = /** @type {(inputs: Invalidorexpiredverificationcode4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Bestätigungscode ist ungültig oder abgelaufen.`)
};

/**
* | output |
* | --- |
* | "Invalid or expired verification code." |
*
* @param {Invalidorexpiredverificationcode4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidorexpiredverificationcode4 = /** @type {((inputs?: Invalidorexpiredverificationcode4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidorexpiredverificationcode4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidorexpiredverificationcode4(inputs)
	return de_invalidorexpiredverificationcode4(inputs)
});
export { invalidorexpiredverificationcode4 as "invalidOrExpiredVerificationCode" }